import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
import { ClipboardModule } from 'ngx-clipboard';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthService } from './modules/auth/services/auth.service';
import {AuthHttpClientInterceptor} from "./modules/auth/services/auth-http/auth-http-client.interceptor";
import {EncryptService} from "./modules/shared/services/encrypt.service";
import { ReportbugComponent } from './modules/reportbug/reportbug.component';
import { SettingsComponent } from './modules/settings/settings.component';
import { AboutUsComponent } from './modules/about-us/about-us.component';
import { ReportHelpComponent } from './modules/report-help/report-help.component';
import { ReportcontinueComponent } from './modules/reportcontinue/reportcontinue.component';
import { ReportsendComponent } from './modules/reportsend/reportsend.component';
import { UserinvitesComponent } from './modules/userinvites/userinvites.component';
import {RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY, RecaptchaFormsModule} from 'ng-recaptcha';
import {environment} from "../environments/environment";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import {TableModule} from "primeng/table";
import {InputTextModule} from "primeng/inputtext";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import { GenericGridComponent } from '../app/modules/shared/components/generic-grid/generic-grid.component';
import { MenuItem } from 'primeng/api';
import {Menu, MenuModule} from 'primeng/menu';
import {
  ChangePassword2Component
} from "./modules/change-password/components/change-password2/change-password2.component";
import {ChangePasswordModule} from "./modules/change-password/change-password.module";
import {MomentModule} from "ngx-moment";
function appInitializer(authService: AuthService) {
  return () => {
    return new Promise((resolve, reject) => {
      authService.getUserByToken().subscribe({
        next: () => {
          resolve(true);
        },
        error: (err) => {
          console.error('Error during app initialization:', err);
          resolve(true);
        },
      });
    });
  };
}

@NgModule({
  declarations: [AppComponent, ReportbugComponent, SettingsComponent, AboutUsComponent, ReportHelpComponent, ReportcontinueComponent, ReportsendComponent, UserinvitesComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        TranslateModule.forRoot(),
        HttpClientModule,
        ClipboardModule,
        FormsModule,
        ReactiveFormsModule,
        RecaptchaV3Module,
        AppRoutingModule,
        TableModule,
        InputTextModule,
        DropdownModule,
        MatSlideToggleModule,
        DropdownModule,
        MenuModule,
        GenericGridComponent,
        InlineSVGModule.forRoot(),
        NgbModule,
        ChangePasswordModule,
        MomentModule,

    ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
      deps: [AuthService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpClientInterceptor,
      multi: true/*,
      deps: [EncryptService],*/
    },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.reCaptchaKey }
  ],
  bootstrap: [AppComponent],
  exports: [
  ]
})
export class AppModule {}
